
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"19","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M4.147 2.311A9.5 9.5 0 0119.857 9.5a9.46 9.46 0 01-1.72 5.453L15.108 9.5h2.85A7.6 7.6 0 005.094 4.017L4.147 2.31zm12.42 14.378A9.5 9.5 0 01.857 9.5c0-2.03.637-3.91 1.72-5.453L5.607 9.5h-2.85a7.6 7.6 0 0012.863 5.483l.947 1.706z","fill":"#495567"}})])
          )
        }
      }
    